var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var fieldNames = {
            city: 'cityId',
            phone: 'phone',
            isChooseCallTime: 'isChooseCallTime',
            callTime: 'callTime',
            callDate: 'callDate'
        };

        var citySelector = '.js-callback-city-value';
        var timeSelector = '.js-callback-time-value';

        var CallRequestForm = function () {
            function CallRequestForm() {
                _classCallCheck(this, CallRequestForm);
            }

            _createClass(CallRequestForm, null, [{
                key: "init",
                value: function init() {
                    CallRequestForm.attachHandlers();
                }

                /**
                 * @param {jQuery} $form
                 * @param {boolean} lock
                 */

            }, {
                key: "toggleSubmitLock",
                value: function toggleSubmitLock($form, lock) {
                    var $submitButton = $form.find('.callback-action-button');
                    $submitButton.prop('disabled', lock).toggleClass('disabled', lock);
                    $form.data('submit-locked', Number(lock));
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this = this;

                    $('body').on('submit', '.callback-form', function (e) {
                        e.preventDefault();
                        var $form = $(e.currentTarget);
                        if (Number($form.data('submit-locked')) === 1) {
                            return;
                        }
                        CallRequestForm.toggleSubmitLock($form, true);

                        var submitCallback = function submitCallback(requestParams) {
                            if (!requestParams.validate()) {
                                if (requestParams.haveError(requestParams.errorFields.PHONE)) {
                                    _this.addError($form.find('[name="' + fieldNames.phone + '"]'));
                                }
                                if (requestParams.haveError(requestParams.errorFields.DATETIME)) {
                                    var $field = $form.find('[name="' + fieldNames.callTime + '"]');
                                    // TODO: hSelect (pseudoSelect)
                                    _this.addError($field);
                                }

                                CallRequestForm.toggleSubmitLock($form, false);
                            } else {
                                CallRequestForm.showLoading($form);
                                window.callRequest.create(requestParams, function (data) {
                                    CallRequestForm.showResultMessage($form, {
                                        success: data.success,
                                        title: data.title,
                                        message: data.message,
                                        allowRepeat: data.allowRepeat,
                                        isChooseCallTime: data.isChooseCallTime,
                                        onAfterShow: function onAfterShow($visible) {
                                            if (data.success) {
                                                var analyticsElement = $visible[0];
                                                window.tracking.formConversion.markCallback(analyticsElement, true);
                                            }
                                        }
                                    });

                                    CallRequestForm.toggleSubmitLock($form, false);
                                });
                            }
                        };

                        var requestParams = window.callRequest.Params.loadForm($form.serializeArray());

                        if (window.app.useGoogleCaptchaForCallback) {
                            // Используем reCAPTCHA
                            window.loadGoogleCaptcha().then(function () {
                                return grecaptcha.execute(window.app.googleCaptchaSiteKey, {
                                    action: 'callback_request'
                                });
                            }).then(function (token) {
                                requestParams.recaptchaToken = token;
                                submitCallback(requestParams);
                            }).catch(function (error) {
                                CallRequestForm.toggleSubmitLock($form, false);
                                CallRequestForm.showResultMessage($form, {
                                    success: false,
                                    title: 'Ошибка',
                                    message: error + 'Не удалось выполнить проверку безопасности. Пожалуйста, попробуйте позже.',
                                    allowRepeat: true,
                                    isChooseCallTime: requestParams.isChooseCallTime
                                });
                            });
                        } else {
                            // Без reCAPTCHA
                            submitCallback(requestParams);
                        }

                        return false;
                    }).on('change', citySelector, function () {
                        var city = window.CityItem.findById(this.value);
                        if (city) {
                            var $form = $(this).closest('.callback-form');
                            $form.find('.callback-phone-number').each(function () {
                                var type = this.getAttribute('data-type');
                                this.innerHTML = city.getPhoneView(type);
                            });
                        }
                    }).on('change', timeSelector, function () {
                        var $wrapper = CallRequestForm.$getFormWrapper($(this));
                        $wrapper.find('.call-time-value-label').html(this.value);
                    }).on('click', '.callback-form-repeat', function () {
                        var $wrapper = CallRequestForm.$getFormWrapper($(this));
                        CallRequestForm.resetState($wrapper);
                    });

                    /**
                     * @param {CityItem} city
                     */
                    $(window).on('onLocation', function (event, city) {
                        $(citySelector + '.allow-change-on-location').each(function () {
                            var $city = $(this);

                            var allowChangeCity = Number(this.value) !== city.id;
                            if (allowChangeCity) {
                                if ($city.is('select') && !window.selectUtils.isContainValue($(this), city.id)) {
                                    allowChangeCity = false;
                                }
                                // TODO: hSelect (pseudoSelect)
                            }

                            if (allowChangeCity) {
                                $city.val(city.id).trigger('change');
                            }
                        });
                    });
                }
            }, {
                key: "addError",
                value: function addError($field) {
                    $field.addClass('has-error');
                    $field.one('click', function () {
                        $(this).removeClass('has-error');
                    });
                }
            }, {
                key: "$getFormWrapper",
                value: function $getFormWrapper($childElem) {
                    return $childElem.closest('.callback-form-body');
                }
            }, {
                key: "resetState",
                value: function resetState($formWrapper) {
                    $formWrapper.removeClass('state-loading state-result');
                }
            }, {
                key: "showLoading",
                value: function showLoading($form) {
                    var $wrapper = CallRequestForm.$getFormWrapper($form);
                    var $loading = $wrapper.find('.callback-form-loading');
                    $loading.html(app.templates.circleLoading);

                    $wrapper.addClass('state-loading');
                }

                /**
                 * @param $form
                 * @param {{
                 *  success: boolean,
                 *  title: string,
                 *  message: string,
                 *  allowRepeat: bool,
                 *  isChooseCallTime: bool,
                 *  onAfterShow: Function
                 * }} data
                 */

            }, {
                key: "showResultMessage",
                value: function showResultMessage($form, data) {
                    var $wrapper = CallRequestForm.$getFormWrapper($form);
                    var $result = $wrapper.find('.callback-form-result');

                    var imageSrc = '';
                    var image = imageSrc ? "<img src=\"" + imageSrc + "\" height=\"150\">" : '';
                    var message = "\n            " + image + "\n            <p class=\"title\">" + data.title + "</p>\n            <p class=\"message\">" + data.message + "</p>\n        ";
                    if (data.allowRepeat) {
                        message += '<button type="button" class="form-control callback-action-button callback-form-repeat">' + 'Повторить</button>';
                    }

                    $result.html(message);
                    $wrapper.removeClass('state-loading').addClass('state-result');

                    if (data.onAfterShow) {
                        data.onAfterShow($result);
                    }
                }
            }]);

            return CallRequestForm;
        }();

        CallRequestForm.init();

        $(document).ready(function () {
            // #ASIDE Form
            $('#aside-callback-form').removeClass('hidden');
            var $asideFormShowButton = $('.aside-callback-show-button');
            $asideFormShowButton.addClass('visible');
            $asideFormShowButton.on('click', function () {
                $('#aside-callback-form').addClass('visible');
            });
            var $asideFormShowHeaderLink = $('.aside-callback-show-header-link');
            $asideFormShowHeaderLink.on('click', function () {
                $('#aside-callback-form').addClass('visible');
            });
            $('.aside-callback-close-button').on('click', function () {
                $('#aside-callback-form').removeClass('visible');
            });

            var lazyLoadRequest = null;
            var loadStylesheetTimeout = 0;
            $('.promo-content-lazy').on('click', function (e) {
                e.preventDefault();

                // const url = $(this).data('href');
                var url = '/promotion-lazy/nauryz';

                function onContentStylesheetsLoaded($loading, $content) {
                    $loading.remove();
                    $content.css('display', 'block');
                }

                popup2({
                    content: '<div class="modal-body-promo-loader">' + window.app.templates.circleLoading + '</div>',
                    theme: 'airplanes',
                    onAfterShow: function onAfterShow($modal) {
                        var $loading = $modal.find('.modal-body-promo-loader');
                        if (lazyLoadRequest) {
                            lazyLoadRequest.abort();
                        }
                        lazyLoadRequest = $.get(url, {}, function (contentHtml) {
                            var $content = $('<div class="modal-body-promo-content" style="display: none;"></div>');
                            $content.html(contentHtml);

                            var $links = $content.find('link[href]');
                            var linksCount = $links.length;
                            var linksLoaded = 0;
                            if (loadStylesheetTimeout) {
                                clearTimeout(loadStylesheetTimeout);
                            }
                            if (linksCount === 0) {
                                $loading.after($content);
                                onContentStylesheetsLoaded($loading, $content);
                            } else {
                                // fallback, если кто-то не умеет в onload
                                loadStylesheetTimeout = setTimeout(function () {
                                    onContentStylesheetsLoaded($loading, $content);
                                }, 2000);
                                $links.each(function () {
                                    this.onload = function () {
                                        linksLoaded++;
                                        if (linksLoaded === linksCount) {
                                            onContentStylesheetsLoaded($loading, $content);
                                            clearTimeout(loadStylesheetTimeout);
                                        }
                                    };
                                });

                                $loading.after($content);
                            }
                        });
                    }
                });
            });
        });
    }, {}] }, {}, [1]);